/**
 * REST client for Tenant Onboarding Wizard.
 */

import { httpRequest } from "@/lib/axios";

export type ClinicType = "estetica" | "fisioterapia" | "psicologia" | "nutricao" | "odontologia" | "geral";

export type OnboardingStatus = {
  id: string;
  clinic_type: ClinicType;
  specialty: string | null;
  team_size: number;
  completed_steps: string[];
  current_step: string;
  is_completed: boolean;
  metadata: Record<string, unknown> | null;
};

export type OnboardingTemplates = {
  procedures: string[];
  growth_team_roles: Array<{
    type: "SDR" | "CLOSER" | "SCHEDULER" | "SUPPORT" | "RETENTION";
    label: string;
    description: string;
  }>;
  greeting_prompt: string;
};

export const ONBOARDING_QUERY_KEY = ["onboarding-status"] as const;

export async function fetchOnboardingStatus(): Promise<OnboardingStatus | null> {
  try {
    const { data } = await httpRequest.get("/onboarding");
    return data;
  } catch {
    return null;
  }
}

export async function updateOnboardingStep(payload: {
  current_step: string;
  completed_steps?: string[];
  clinic_type?: ClinicType;
  specialty?: string;
  team_size?: number;
  metadata?: Record<string, unknown>;
}): Promise<OnboardingStatus | null> {
  try {
    const { data } = await httpRequest.put("/onboarding/step", payload);
    return data;
  } catch {
    return null;
  }
}

export async function completeOnboarding(): Promise<OnboardingStatus | null> {
  try {
    const { data } = await httpRequest.post("/onboarding/complete");
    return data;
  } catch {
    return null;
  }
}

export async function fetchOnboardingTemplates(clinicType?: ClinicType): Promise<OnboardingTemplates | null> {
  try {
    const params = clinicType ? `?clinic_type=${clinicType}` : "";
    const { data } = await httpRequest.get(`/onboarding/templates${params}`);
    return data;
  } catch {
    return null;
  }
}
